export default "__VITE_ASSET__$YGjhPNj__"